export default "__VITE_ASSET__DtM866V8__"